module.exports = __webpack_public_path__ + "img/cert-flower.7b3169e8.png";